import AppConstants from '../constants/app-constants';
import AppUtils from '../utils/app-utils';
import AppActions from '../actions/app-actions';

//import Cookies from 'universal-cookie';
import AppWebsocket from '../utils/app-websocket';

const WebsocketService = store => next => action => {
    // Pass all actions through by default
    next(action)
    
    switch (action.type) {
        case AppConstants.LOGIN:
            AppUtils.post(import.meta.env.VITE_API+"/login", action.data, AppActions.LoginSuccess, AppActions.LoginFailure, next);
            break;
        case AppConstants.LOGIN_TOKEN:
            AppUtils.post(import.meta.env.VITE_API+"/login_token", action.data, AppActions.LoginSuccess, AppActions.LoginFailure, next);
            break;
        case AppConstants.LOGIN_TOKEN_WEBSOCKET:
            AppWebsocket.sendMessage(AppActions.MWebsocketLoginToken(action.data));
            break;
        case AppConstants.LOGOUT:
            AppUtils.post(import.meta.env.VITE_API+"/logout", action.data, AppActions.LogoutSuccess, undefined, next);
            break;
        case AppConstants.UPDATE:
            AppUtils.post(import.meta.env.VITE_API+"/update", action.data, AppActions.UpdateSuccess, AppActions.UpdateFailure, next);
            break;
        case AppConstants.REGISTER:
            AppUtils.post(import.meta.env.VITE_API+"/register", action.data, AppActions.RegisterSuccess, AppActions.RegisterFailure, next);
            break;
        case AppConstants.WEBSOCKET_STATE:
            if(action.payload.state === AppConstants.STATE_WEBSOCKET_ONLINE) {
                const cookieConsent = AppUtils.getAllowCookiesCookie();
                if (cookieConsent && cookieConsent.moes_random_value) {
                    AppWebsocket.sendMessage(AppActions.MWebsocketConsentCookie({value: cookieConsent.moes_random_value}));
                }
            }
            break;
        case AppConstants.CREATE_LOBBY:
            AppUtils.post(import.meta.env.VITE_API+"/create", action.data, AppActions.CreateLobbySuccess, AppActions.CreateLobbyFailure, next);
            break;
        case AppConstants.JOIN_LOBBY:
            AppUtils.post(import.meta.env.VITE_API+"/join", action.data, AppActions.JoinLobbySuccess, AppActions.JoinLobbyFailure, next);
            break;
        case AppConstants.LEAVE_LOBBY:
            AppWebsocket.sendMessage(AppActions.MWebsocketLeaveLobby(action.data));
            break;
        case AppConstants.KICK:
            AppWebsocket.sendMessage(AppActions.MWebsocketKick(action.data));
            break;
        case AppConstants.LEAVE_LOBBY_SILENT:
            AppUtils.post(import.meta.env.VITE_API+"/leave_lobby_silent", action.data, AppActions.LeaveLobbySilentSuccess, AppActions.LeaveLobbySilentFailure, next, true);
            break;
        case AppConstants.GAME_START:
            AppWebsocket.sendMessage(AppActions.MWebsocketGameStart(action.data));
            break;
        case AppConstants.GAME_ANSWER:
            AppWebsocket.sendMessage(AppActions.MWebsocketGameAnswer(action.data));
            break;
        case AppConstants.READY:
            AppWebsocket.sendMessage(AppActions.MWebsocketReady(action.data));
            break;
        case AppConstants.PING:
            AppWebsocket.sendMessage(AppActions.MWebsocketPong(action.data));
            break;
        case AppConstants.COOKIE:
            AppWebsocket.sendMessage(AppActions.MWebsocketCookie(action.data));
            break;
        case AppConstants.COOKIE_VALIDATE:
            AppUtils.post(import.meta.env.VITE_API+"/validate_cookies", action.data, AppActions.CookieValidateSuccess, AppActions.CookieValidateFailure, next);
            break;
        case AppConstants.REMATCH_LOBBY:
            AppWebsocket.sendMessage(AppActions.MWebsocketRematchLobby(action.data));
            break;
        case AppConstants.SPEAKER_NEXT:
            AppWebsocket.sendMessage(AppActions.MWebsocketSpeakerNext(action.data));
            break;
        // Do nothing if the action does not interest us
        default:
            break;
    }
};

export default WebsocketService;
